import { serviceBackgroundChecks } from "./serviceBackgroundChecks";
import { IBackgroundChecksPackageResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const getBackgroundChecksPackages = async (): Promise<
  IBackgroundChecksPackageResponse[]
> => {
  const { data } = await serviceBackgroundChecks.get(`/package`);
  return data;
};
